import { createContext, useContext, type ReactNode } from "react";

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

export type PageMeta = {
  title?: string;
  description?: string;
  actions?: ReactNode;
  breadcrumbs?: BreadcrumbItem[];
};

export type PageHeaderContextValue = {
  meta: PageMeta;
  setMeta: (next: PageMeta) => void;
  clearMeta: () => void;
};

export const PageHeaderContext = createContext<PageHeaderContextValue | null>(null);

export function usePageHeaderMeta(): PageMeta {
  const ctx = useContext(PageHeaderContext);
  return ctx?.meta ?? {};
}

export function usePageHeaderSetter() {
  const ctx = useContext(PageHeaderContext);
  return ctx;
}
